<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import type { OptionsSet } from "./types";

    export let optionsSet: OptionsSet;
    export let value: null | string;
    export let name: string;
    const dispatch = createEventDispatcher();
    const handleOption = (value: string) => {
        dispatch("change", value);
    };
</script>

<fieldset class="gw-select-option gw-default-reset">
    <legend class="gw-select-option__title gw-default-reset">
        {optionsSet.name}
    </legend>
    {#each optionsSet.options as option}
        <label>
            <input
                type="radio"
                class="gw-select-option__input gw-hide-elements"
                {name}
                value={option.value}
                checked={value === option.value}
                on:click={() => handleOption(option.value)}
            />
            <span class="gw-select-option__text">
                {option.value}
            </span>
        </label>
    {/each}
</fieldset>

<style>
    .gw-select-option {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        width: 100%;
        border: none;
        text-align: start;
        gap: 10px;
    }

    .gw-select-option__title {
        margin-bottom: 10px;
        color: var(--gw-post-modal-text-color);
        font-size: 0.9em;
        font-weight: var(--gw-font-weight-semibold);
    }

    .gw-select-option__text {
        padding: 10px 16px;
        border-radius: 4px;
        color: var(--gw-post-modal-text-color);
        font-size: 1em;
        cursor: pointer;
        box-shadow: 0px 0px 5px 2px var(--gw-select-option-border);
        background: var(--gw-select-option-bg, none);
    }

    :global(.gw-post-modal__dark) .gw-select-option__text {
        box-shadow: none;
    }

    .gw-select-option__text:hover {
        background: var(--gw-active-select-option-bg);
        color: var(--gw-active-select-option-text-color);
    }

    .gw-select-option__input:checked + .gw-select-option__text {
        background: var(--gw-active-select-option-bg);
        color: var(--gw-active-select-option-text-color);
        cursor: default;
    }
</style>
